import React from "react";
import { Link } from "react-router-dom";
import { Offer } from "../utils/API";

const BrandRecommendation: React.FC<{
  brandRecommendationData: Offer[];
  detailLinkParams?: {
    source: string;
    brandType: string;
  };
}> = ({ brandRecommendationData, detailLinkParams }) => {
  const getBrandName = (item: Offer) => {
    if (item.merchant_name) return item.merchant_name;
    if (!item.store) return "";
    return item.store.replace(/\.com$/, "");
  };

  const buildDetailLink = (item: Offer) => {
    const params = new URLSearchParams({
      offer_id: item.offer_id,
      store: item.store,
    });
    if (detailLinkParams?.source) {
      params.set("source", detailLinkParams.source);
    }
    if (detailLinkParams?.brandType) {
      params.set("brand_type", detailLinkParams.brandType);
    }
    return `/branddiscountcode?${params.toString()}`;
  };

  return (
    <ul className="gap-3.5 lg:flex-col h-auto grid md:grid-cols-2 lg:grid-cols-1">
      {brandRecommendationData?.map((item) => {
        const logoUrl = (item.brand_logo || "")
          .replace("[size]", "200")
          .replace("[format]", "png");
        return (
          <Link
            to={buildDetailLink(item)}
            key={item.offer_id}
            target="_top"
            rel="noopener noreferrer"
            className="border-[1px] border-white rounded-lg bg-white/10"
          >
            <li className="w-full h-full group cursor-pointer">
              <div className="flex items-center justify-center gap-4">
                <div className="rounded-md">
                  <img
                    src={logoUrl}
                    alt={getBrandName(item) || "brand logo"}
                    loading="lazy"
                    decoding="async"
                    width="80"
                    height="80"
                    onError={(e) => {
                      const target = e.currentTarget;
                      if (target.src.endsWith("/images/white.png")) return;
                      target.src = "/images/white.png";
                    }}
                    className="w-[80px] h-[80px] rounded-md object-contain transition-all hover:shadow-lg px-1 bg-white"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col gap-2.5 text-base text-white group-hover:underline transition-all duration-300">
                  <div className="font-bold leading-[18px] capitalize line-clamp-1">
                    {getBrandName(item)}
                  </div>
                  <div className="font-semibold leading-4 capitalize line-clamp-1">
                    {item.label}
                  </div>
                </div>
              </div>
            </li>
          </Link>
        );
      })}
    </ul>
  );
};

export default BrandRecommendation;
